<template>
    <div class="sign-user-card">
        <el-card shadow="always">
            <div slot="header" class="clearfix card-title">
                <span>{{ title }}</span>
            </div>
            <!-- 邮箱找回 -->
            <el-form 
                v-if="backWay === 'EMAIL'"
                ref="emailForm" 
                :model="form" 
                label-position="left" 
                :rules="rules">
                <el-form-item label="" prop="email">
                    <el-input 
                        type="text" 
                        :placeholder="$t('Placeholder.EnterEmail')" 
                        v-model.trim="form.email" 
                        clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="" prop="captcha" class="captcha-img">
                    <el-input 
                        type="text" 
                        :placeholder="$t('Placeholder.EnterCaptcha')" 
                        v-model.trim="form.captcha">
                        <img slot="suffix" :src="captchaImgUrl" @click="getImgCaptcha" />
                    </el-input>
                </el-form-item>
                <!-- <el-button type="text" class="back-way" @click="handleBackWay('SMS')">{{$t('Form.SmsBack')}}</el-button> -->
            </el-form>
            
            <!-- 手机短信验证码找回 -->
            <el-form 
                v-if="backWay === 'SMS'"
                ref="smsForm" 
                :model="form" 
                label-position="left" 
                :rules="rules">
                <el-form-item label="" prop="phone">
                    <el-input 
                        type="text" 
                        :placeholder="$t('Placeholder.EnterPhoneNumber')" 
                        v-model.trim="form.phone" 
                        clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="" prop="code" class="captcha-sms">
                    <el-input
                        type="text" 
                        :placeholder="$t('Placeholder.PleaseEnterSmsCaptcha')" 
                        v-model.trim="form.code" 
                        maxlength="6">
                        <div 
                            slot="append"  
                            @click="getSmsCaptcha" 
                            v-if="!showCountdown" 
                            v-loading="smsLoading">
                            {{ countdown === 0 ? $t('Form.Reacquire') : $t('Form.GetSmsCaptcha')}}
                        </div>
                        <div slot="append" v-if="showCountdown">{{`${countdown} 秒`}}</div>
                    </el-input>
                </el-form-item>
                <el-button type="text" class="back-way" @click="handleBackWay('EMAIL')">{{$t('Form.EmailBack')}}</el-button>
            </el-form>

            <div class="card-footer">
                <el-button v-waves class="card-btn-login" @click="toLogin">{{ $t('Button.ToLogin') }}</el-button>
                <el-button v-waves :loading="btnLoading" class="card-btn-submit" type="primary" @click="handleSubmit">{{ $t('Button.Next') }}</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import waves from '@/directive/waves' // Waves directive
import { validate_email, validate_phone } from '@/utils/validate/resetPassword'
import { validate_captcha_img, validate_captcha_sms } from '@/utils/validate/register'
import { apiGetCaptcha, apiSendSmsCaptcha } from '@/api/register'
import { apiCaptchaEmailValidate, apiCaptchaPhoneValidate } from '@/api/resetPassword'
import { FormMixin } from '@/mixins'

export default {
    props: {
        title: { type: String, default: '' },
    },
    directives: { waves },
    mixins: [FormMixin],
    name: 'SignUserCard',
    data() {
        return {
            backWay: 'EMAIL',  //密码找回方式
            smsLoading: false,   //获取短信验证码按钮loading
            btnLoading: false,
            form: {
                email: '',
                captcha: '',
                phone: '',
                code: '',
            },
            rules: {
                email: { validator: validate_email.bind(this), trigger: 'blur' },
                captcha: { validator: validate_captcha_img.bind(this), trigger: 'blur' },
                phone: { validator: validate_phone.bind(this), trigger: 'blur' },
                code: { validator: validate_captcha_sms.bind(this), trigger: 'blur' },
            },
            captchaImgUrl: '',
            countdown: 60,        //短信验证码倒计时初始值
            showCountdown: false, //是否显示短信验证码倒计时
            timer: null,          //倒计时定时器
        }
    },
    computed: {
        ...mapGetters(['language', 'size']),
    },
    methods: {
        handleBackWay(way){
            this.$set(this, 'backWay', way)
            if(way === 'EMAIL' && this.$refs.smsForm){
                this.$refs.smsForm.resetFields()
            }else if(way === 'SMS' && this.$refs.emailForm){
                this.$refs.emailForm.resetFields()
            }
        },
        // 获取图形验证码
        getImgCaptcha() {
            this.captchaImgUrl = apiGetCaptcha.url + '?timestamp=' + new Date().getTime() + '&email=' + this.form.email
        },
        //获取短信验证码
        getSmsCaptcha(){
            if(this.form.phone){
                this.smsLoading = true
                apiSendSmsCaptcha({
                    phone: this.form.phone,
                    status: 2
                }).then(res => {
                    //调取获取短信验证码的接口，成功后弹出提示并开始倒计时
                    this.smsLoading = false
                    this.$message.success(this.$t('Message.SendSuccess'))
                    this.showCountdown = true  //显示短信验证码倒计时 
                    this.countdownFun()
                }).catch(err => {
                    this.smsLoading = false
                    this.$message.error(this.$t( `Message.MsgCode${err.code}`))
                })
            }else{
                this.$message.warning(this.$t('Message.NotPhone'))
            }
        },
        //倒计时函数
        countdownFun() {
            this.countdown = 60
            this.timer = setInterval(() =>{
                this.countdown--;
                if (this.countdown == 0) {
                    clearInterval(this.timer);
                    this.showCountdown = false
                } 
            },1000)
        },
        handleSubmit() {
            if(this.backWay === 'EMAIL'){
                this.$refs.emailForm.validate(valid => {
                    if (valid) {
                        this.btnLoading = true
                        apiCaptchaEmailValidate({
                            email: this.form.email,
                            captcha: this.form.captcha,
                            language: this.language === 'zh' ? '' : 'en'
                        }).then(res => {
                            if (res.data.status === 200) {
                                this.$message.success(this.$t('Message.MsgCode' + res.data.code))
                                this.$emit('nextStepClick', 'EMAIL', this.form.email)
                            } else {
                                this.$message.error(this.$t('Message.MsgCode' + res.data.code))
                            }
                            this.btnLoading = false
                        })
                    }
                })
            }else if(this.backWay === 'SMS'){
                this.$refs.smsForm.validate(valid => {
                    if (valid) {
                        this.btnLoading = true
                        apiCaptchaPhoneValidate({
                            phone: this.form.phone,
                            code: this.form.code
                        }).then(res => {
                            this.$message.success(this.$t('Message.VerifiySuccess'))
                            this.$emit('nextStepClick', 'SMS', res.data.key)
                            this.btnLoading = false
                        }).catch(err => {
                            this.btnLoading = false
                            this.$message.error(this.$t('Message.MsgCode' + err.code))
                        })
                    }
                })
            }
            
        },
    },
    mounted(){
        this.$nextTick(() => {
            this.getImgCaptcha()  //获取图形验证码
        })
    },
    beforeDestroy(){
        // vue实例销毁前，若存在定时器则清除
        if(this.timer) clearInterval(this.timer)
    },
}
</script>

<style lang="scss" scoped>
$color-theme: #4da1ff;
$color-black: #000000;

.sign-user-card {
    .el-card {
        /*padding: 30px 0 20px 0;*/
    }
    .card-footer {
        padding: 30px 0 20px 0;
        width: 80%;
        margin: 0 auto;
        .card-btn-submit {
            width: 45%;
        }
        .card-btn-login {
            width: 45%;
        }
    }
    .el-form-item {
        margin-bottom: 30px;
    }
    .captcha-img {
        margin-bottom: 10px !important;
        ::v-deep .el-input__suffix{
            right: 0 !important;
        }

        img{
            width: 160px;
            height: 40px;
            cursor: pointer;

            border-top-right-radius: 25px;
            border-bottom-right-radius: 25px;
        }
    }

    .captcha-sms{
        margin-bottom: 10px !important;
        ::v-deep .el-form-item__content{
            .el-input__inner{
                border-radius: 25px 0 0 25px !important;
            }

            .el-input-group__append{
                width: 160px;
                padding: 0;
                border: 1px solid #bbb;
                border-left: 0;
                border-radius: 0 25px 25px 0;
                color: $color-black;
                background-image: linear-gradient(to right ,#C1C1C1, #F8F8F8);
                cursor: pointer;
                text-align: center;

                .el-loading-mask{
                    top: -9px;
                    bottom: -10px;
                    border-radius: 0 25px 25px 0;
                }
            }
        }
    }

    .el-button--text{
        &.back-way{
            color: #0000FF;
        }
    }
}
</style>
